module.exports = __webpack_public_path__ + "static/media/scheme4.ad007309.png";